import { SessionResponseChunkSchema } from '../schemas/sessionResponseChunk'
import { ProjectUserSessionDetailResponseSchema } from '../schemas/projectListSchemas'

export async function loadSessionDetail(first: unknown, fetchPart: (part: number, sha256: string) => Promise<unknown>) {
  const initial = SessionResponseChunkSchema.safeParse(first)
  if (!initial.success) return ProjectUserSessionDetailResponseSchema.parse(first)
  const start = initial.data
  if (start.part !== 0) throw new Error('Session analysis did not start at the first response part')
  const chunks = [start.data]
  for (let part = 1; part < start.parts; part++) {
    const next = SessionResponseChunkSchema.parse(await fetchPart(part, start.sha256))
    if (next.part !== part || next.parts !== start.parts || next.sha256 !== start.sha256) {
      throw new Error('Session analysis changed while loading. Please reload.')
    }
    chunks.push(next.data)
  }
  const bytes = Uint8Array.from(atob(chunks.join('')), character => character.charCodeAt(0))
  const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'))
  const body = await new Response(stream).text()
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(body))
  const sha256 = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('')
  if (sha256 !== start.sha256) throw new Error('Session analysis response checksum mismatch')
  return ProjectUserSessionDetailResponseSchema.parse(JSON.parse(body))
}
